export const primaryColor = '#ffffff';
export const primaryBgColor = '#270B33';
export const ForeColorYellow = "#FFCC05";
export const ForeColorPurple = "#5F297B";
export const ForeColorBlack = "#323232";
